import React from 'react';
import { GuidePage } from './pages/GuidePage';
export function App() {
  return <GuidePage data-id="element-0" />;
}